import React, { useContext } from 'react'
import Header from './components/Header';
import { Outlet, useLocation, useMatches } from 'react-router-dom';
import { Breadcrumb, message, Layout } from 'antd';
import AuthContext from '../utils/AuthContext';



const MyLayout = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const pathName = location.pathname.replaceAll('-', ' ');
  const matches = useMatches();
  const { user } = useContext(AuthContext);

  let crumbs = matches 
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one 
    .map((match) => match.handle.crumb(match.data));


  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  }; 

  // const successLoading = (type) => {
  //   messageApi.open({
  //     type: 'loading',
  //     content: 'Action in progress..',
  //     duration: 0,
  //   });
  //   // Dismiss manually and asynchronously
  //   setTimeout(messageApi.destroy, 2500);
  // };

  const CustomBreadcrumb = () => {
    return (
      <Breadcrumb>
        {crumbs.map((crumb, idx) => 
          <Breadcrumb.Item key={idx}>{crumb}</Breadcrumb.Item>
        )}
      </Breadcrumb>
    )
  };

  return (
    <div className='bg-slate-100'>
      <Header user={user}/>
      {contextHolder}
      <div >
        <Outlet context={{success, error, CustomBreadcrumb}}/>
      </div>
    </div>
  )
}

export default MyLayout;